var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineAdditionalInvestigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2,5V2c0-0.4,0.3-0.8,0.8-0.8S8.8,1.6,8.8,2v3c0,0.4-0.3,0.8-0.8,0.8S7.2,5.4,7.2,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,5V2c0-0.4,0.3-0.8,0.8-0.8 s0.8,0.3,0.8,0.8v3c0,0.4-0.3,0.8-0.8,0.8S15.2,5.4,15.2,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,22.8c-3.7,0-5.8-2.1-5.8-5.8V8.5 c0-3.7,2.1-5.8,5.8-5.8h8c3.6,0,5.8,2.1,5.8,5.8v5.1c0,0.3-0.2,0.6-0.4,0.7c-0.3,0.1-0.6,0.1-0.8-0.1c-1.6-1.3-4-1.3-5.6,0 c-1.1,0.9-1.8,2.1-1.8,3.5c0,0.8,0.2,1.6,0.6,2.3c0.3,0.5,0.8,1.1,1.3,1.4c0.3,0.2,0.4,0.4,0.3,0.7c-0.1,0.3-0.2,0.7-0.7,0.7H8.4 H8z M3.8,8.5V17c0,2.9,1.4,4.2,4.2,4.2h4.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.6-0.9-0.9-2-0.9-3.1c0.1-1.9,0.8-3.6,2.3-4.7 c1.7-1.4,4.2-1.7,6.2-0.8V8.5c0-2.9-1.4-4.2-4.2-4.2H8l0,0C5.1,4.2,3.8,5.6,3.8,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,11.8c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h6c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,16.8c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h2.6c0.4,0,0.8,0.3,0.8,0.8c0,0.5-0.3,0.8-0.8,0.8H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,22.6c-0.6-0.5-1.2-1.1-1.6-1.8 c-0.6-0.9-0.9-2-0.9-3.1c0-1.8,0.8-3.5,2.3-4.7c2.1-1.7,5.4-1.7,7.5,0c1.4,1.1,2.3,2.9,2.3,4.7c0,1.1-0.3,2.2-0.9,3.1 c-0.3,0.5-0.7,1-1.2,1.4c-1.1,1-2.5,1.5-3.9,1.5C16.5,23.8,15.3,23.4,14.2,22.6z M14.9,14.2c-1.1,0.9-1.7,2.1-1.7,3.5 c0,0.8,0.2,1.6,0.6,2.3c0.3,0.5,0.7,1,1.2,1.3c0.8,0.6,1.7,0.9,2.6,0.9c1.1,0,2.1-0.4,3-1.1c0.4-0.3,0.6-0.6,0.9-1.1 c0.4-0.7,0.7-1.5,0.7-2.3c0-1.4-0.6-2.7-1.7-3.5c-0.8-0.6-1.8-1-2.8-1C16.7,13.3,15.7,13.6,14.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,20.1v-5c0-0.4,0.3-0.8,0.8-0.8 c0.4,0,0.8,0.3,0.8,0.8v5c0,0.4-0.3,0.8-0.8,0.8C17.2,20.8,17,20.5,17,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,18.6c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h5c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H15.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineAdditionalInvestigation);
export default __webpack_public_path__ + "static/media/outline-additional-investigation.80e2aef32bad52f9c1c6e42c98966937.svg";
export { ForwardRef as ReactComponent };